var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-content",
        { attrs: { id: "archived-stories-previews" } },
        [
          _c(
            "v-container",
            {
              class: { "px-0": _vm.$vuetify.breakpoint.smAndUp },
              attrs: { white: "", "fill-height": "", fluid: "", "pt-5": "" }
            },
            [
              _vm.archivedStories.length > 0
                ? _c(
                    "v-data-iterator",
                    {
                      attrs: {
                        items: _vm.archivedStories,
                        "rows-per-page-text": "Past data stories",
                        pagination: _vm.dataStoryPagination,
                        "no-data-text":
                          "The Data Stories Archive is currently empty",
                        "content-tag": "v-layout",
                        row: "",
                        wrap: "",
                        loading: ""
                      },
                      on: {
                        "update:pagination": function($event) {
                          _vm.dataStoryPagination = $event
                        }
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "item",
                            fn: function(props) {
                              return _c(
                                "v-flex",
                                { attrs: { xs12: "", md4: "" } },
                                [
                                  _c(
                                    "v-card",
                                    [
                                      _c(
                                        "v-card-title",
                                        { attrs: { "primary-title": "" } },
                                        [
                                          _c("h4", [
                                            _vm._v(
                                              _vm._s(props.item.story.title)
                                            )
                                          ])
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("v-img", {
                                        attrs: {
                                          src: require("@/assets/img/datastories/" +
                                            _vm.getTeaserImage(
                                              props.item.images
                                            )),
                                          height: "125px"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("v-card-text", [
                                        _c("div", [
                                          _c("div", [
                                            _vm._v(
                                              _vm._s(props.item.story.teaser)
                                            )
                                          ])
                                        ])
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: {
                                            small: "",
                                            flat: "",
                                            round: "",
                                            color: "primary"
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.toggleArchivedStory(
                                                props.item.id,
                                                props.index,
                                                $event
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.archivedStoriesButtons[
                                                _vm.calculateButtonIndex(
                                                  props.index
                                                )
                                              ]
                                            )
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            }
                          }
                        ],
                        null,
                        false,
                        2087781052
                      )
                    },
                    [
                      _c(
                        "v-toolbar",
                        {
                          attrs: {
                            slot: "header",
                            color: "secondary",
                            flat: ""
                          },
                          slot: "header"
                        },
                        [
                          _c("v-toolbar-title", [
                            _vm._v("Data Stories Archive")
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-content",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showArchived,
              expression: "showArchived"
            }
          ]
        },
        [
          _c(
            "v-container",
            {
              class: { "px-0": _vm.$vuetify.breakpoint.smAndUp },
              attrs: { white: "", "fill-height": "", fluid: "", "py-0": "" }
            },
            [
              _c(
                "v-layout",
                { attrs: { row: "", wrap: "", "align-center": "" } },
                [
                  _c(
                    "v-content",
                    [
                      _vm.showArchived
                        ? _c("data-story", {
                            attrs: {
                              id: "archived-story-expanded",
                              datastory: _vm.selectArchived(),
                              archived: _vm.showArchived
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-63559086", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-63559086","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/StoryArchive.vue
// module id = null
// module chunks = 